import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/compat/app'
import Login from '@/components/user/Login'
import Farm from '@/components/farm/Farm'
// import Settings from '@/components/user/Settings'
import Script from '@/components/Script'
import Admin from '@/components/admin/Admin'
import VariableRateMode from '@/components/plugins/VariableRateMode'
import SatelliteImagery from '@/components/plugins/satellite/SatelliteImagery.vue'
import Figures from '@/components/plugins/figures/Figures.vue'
import RasterAnalysis from '@/components/plugins/raster-analysis/RasterAnalysis.vue'
import Interpolator from '@/components/plugins/interpolator/Interpolator.vue'
import GridGenerator from '@/components/plugins/grid-generator/Home.vue'
import Translator from '@/components/plugins/translator/Home.vue'
import DataJoiner from '@/components/plugins/data-joiner/Home.vue'
import Multivariate from '@/components/plugins/multivariate/Home.vue'
import Missions from '@/components/plugins/missions/Missions.vue'
import InviteAccept from '@/components/user/InviteAccept.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login/:mode?',
      name: 'Login',
      component: Login
    },
    // {
    //   path: '/settings',
    //   name: 'Settings',
    //   component: Settings,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/script',
      name: 'Script',
      component: Script,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/f/:id?/:layerType?/:layerId?/:mode?',
      name: 'Farm',
      component: Farm,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: {
        requiresAuth: true,
        requiresSuperAdmin: true
      }
    },
    {
      path: '/variable-rate-mode',
      name: 'VariableRateMode',
      component: VariableRateMode,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/satellite-imagery',
      name: 'SatelliteImagery',
      component: SatelliteImagery,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/figures',
      name: 'Figures',
      component: Figures,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/raster-analysis',
      name: 'RasterAnalysis',
      component: RasterAnalysis,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/interpolator',
      name: 'Interpolator',
      component: Interpolator,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/grid-generator',
      name: 'GridGenerator',
      component: GridGenerator,
      meta: {
        requiresAuth: true
      }
    },
    {
      // Mission Dispatch (docs/mission-dispatch-v1.md). Restricted plugin:
      // the Plugins drawer only shows it when farm.plugins includes
      // 'missions', which only the super-admin FarmManager toggle grants.
      path: '/missions',
      name: 'Missions',
      component: Missions,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/translator',
      name: 'Translator',
      component: Translator,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/data-joiner',
      name: 'DataJoiner',
      component: DataJoiner,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/multivariate',
      name: 'Multivariate',
      component: Multivariate,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/invite/:id',
      name: 'InviteAccept',
      component: InviteAccept,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '*',
      redirect: '/f'
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const requiresSuperAdmin = to.matched.some(x => x.meta.requiresSuperAdmin)
  const currentUser = firebase.auth().currentUser

  if (requiresAuth && !currentUser) {
    // Preserve the originally-requested URL so Login.vue can bounce
    // the user back after a successful sign-in. The invite-accept
    // page is the most important caller — a colleague clicking
    // /invite/xyz needs to land back at /invite/xyz, not /farm.
    const redirect = to.fullPath && to.fullPath !== '/login'
      ? to.fullPath
      : null
    next(redirect ? { path: '/login', query: { redirect } } : '/login')
    return
  }
  // Super-admin gate. The router guard intentionally re-checks the
  // admins/{uid} doc directly rather than trusting Vuex state — on a
  // cold reload / deep link the user may hit this guard before
  // fetchUserProfile finishes populating state.isSuperAdmin. A direct
  // Firestore read is the source of truth, and the rules deny reading
  // anyone else's admin doc so this is just verifying the user's own
  // membership.
  if (requiresSuperAdmin && currentUser) {
    try {
      const fb = require('../firebaseConfig.js')
      const snap = await fb.db.collection('admins').doc(currentUser.uid).get()
      const isAdmin = snap.exists && snap.data().admin === true
      if (!isAdmin) {
        // Send the user back to the farm root and surface why if
        // possible. We don't `next(false)` because that leaves the
        // navigation in a half-resolved state in some Vue Router
        // versions; a redirect is cleaner.
        next('/')
        return
      }
    } catch (e) {
      next('/')
      return
    }
  }
  next()
})

export default router
